/* eslint-disable*/
import React, { useEffect } from 'react';
import { generatePath } from 'react-router-dom';
import moment from 'moment';
import validator from 'validator';
import { createState, useState, Downgraded } from '@hookstate/core';
import
{
    Box,
    TextField,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Typography,
    Divider,
    CircularProgress,
    Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import Stack from '@mui/material/Stack';
import AppConstants from '../../../constants/appConstants';
// import stores
import { updateModuleState } from '../../../stores/eventStore';
// import utility and constants
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
import APIURLConstants from '../../../config/config';
import RouteConstants from '../../../constants/routeConstants';
// import shared components
import ButtonContainer from '../../../sharedcomponents/buttoncontainer/buttonContainer';
import ParticipantAutoList from '../../../sharedcomponents/participantAutoList/participantAutoList';
// import local components
import CreateDateTimeLocation from './createDateTimeLocation';
// import icons
import SedanBlue from '../../../assets/images/sedan_blue.svg';
import SedanBlackSmall from '../../../assets/images/sedan_black_small.svg';
import IconPencil from '../../../assets/images/Icon_Pencil.svg';
import trash from '../../../assets/images/trash.svg';
import { useAgentState } from '../../../hookState/AgentState';
import PhoneNumber from '../../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../../sharedcomponents/datePicker';

const vehicleTypes = [
    {
        value: 'SUV',
        label: 'SUV',
    },
    {
        value: 'Sedan',
        label: 'Sedan',
    },
];

const passengers = [
    {
        value: 1,
        label: 1,
    },
    {
        value: 2,
        label: 2,
    },
    {
        value: 3,
        label: 3,
    },
    {
        value: 4,
        label: 4,
    },
];

const gTransportState = createState({
    firstName: '',
    lastName: '',
    email: '',
    contactNo: '',
    pickupAddress: '',
    vehicleType: 'SUV',
    totalPassengers: 1,
    pickupDate: null,
    pickupTime: null,
    peopleInfo: [
        {
            name: null,
            dob: `${Helper.FormatYearDate(new Date())}T${Helper.FormatTime24(
                new Date()
            )}`,
        },
    ],
    dropoffList: [],
    draftCombineTransportID: 0,
    draftCombineGroundTransportID: '',
    isDisable: false,
    dateTimeError: false,
    dateTimeErrorMsg: '',
    addedFor: 0,
});

const useStyles = makeStyles({
    mobileLogo: {
        height: 42,
    },
    sedanBlack: {
        height: 18,
        width: 36,
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
});

const GroundTransport = (props) =>
{
    const classes = useStyles();
    const state = useState(gTransportState);
    const currentTransportInfo = useState(null);
    const openDialog = useState(false);
    //const transitInfo = useState(null);
    const prevTransInfo = useState(null);
    const stateObj = useState(null);
    const loading = useState(false);
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [lastNameErr, setLastNameErr] = React.useState('');
    const [emailErr, setEmailErr] = React.useState('');
    const [allParticipantList, setAllParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentInfo');
    const userInfo = Helper.getStorage('userInfo');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [endTimeErr, setEndTimeErr] = React.useState('');
    // const [autoApprove, setAutoApprove] = React.useState(0);

    const handleDateTime = (event) =>
    {
        // let date = `${Helper.FormatYearDate(
        //     event
        // )}T${Helper.FormatTime24(event)}:00`
        state.pickupDate.set(event);

        if (
            state.draftCombineTransportID.get() == 0 &&
            moment(state.pickupDate.get()).isBefore(new Date(), 'day')
        )
        {
            state.dateTimeErrorMsg.set(
                'Pickup date should be minimum todays date'
            );
        } else if (moment(state.pickupDate.get()).isValid() == false)
        {
            state.dateTimeErrorMsg.set('Please select Valid Date & Time');
        } else
        {
            state.dateTimeErrorMsg.set('');
        }
        handleDisableBtn();
    };
    const handleEndTime = (newValue) =>
    {
        handleDisableBtn();
        state.pickupTime.set(newValue);

        let value = state.pickupTime.value;
        if (value == null)
        {
            setEndTimeErr('Please Enter Pickup Time');
        } else
        {
            setEndTimeErr('');
            return true;
        }
    };
    const validateFirstName = () =>
    {
        let value = state.firstName.get().trim();
        if (value == '')
        {
            setFirstNameErr('');
            return true;
        }
        if (validator.isAlpha(value))
        {
            setFirstNameErr('');
            return true;
        } else setFirstNameErr('Please Enter Valid Name');
        return false;
    };
    const validateLastName = () =>
    {
        let value = state.lastName.get().trim();
        if (value == '')
        {
            setLastNameErr('');
            return true;
        }
        if (validator.isAlpha(value))
        {
            setLastNameErr('');
            return true;
        } else setLastNameErr('Please Enter Valid Name');
        return false;
    };
    const validateEmail = () =>
    {
        let value = state.email.get().trim();
        if (value == '')
        {
            setEmailErr('');
            return true;
        }
        if (validator.isEmail(value))
        {
            setEmailErr('');
            return true;
        } else
        {
            setEmailErr('Please enter valid emailid');
            return false;
        }
    };
    // const validatePhone = (e) =>
    // {
    //     let value = e.target.value.trim();
    //     if (value == '')
    //     {
    //         setPhoneErr('');
    //         return true;
    //     }
    //     if (validator.isMobilePhone(value))
    //     {
    //         setPhoneErr('');
    //         return true;
    //     } else setPhoneErr('Please enter valid contact number');
    //     state.contactNo.set(value);
    //     return false;
    // };

    // function handleChange(event,i) {
    //   const values = [...gTransportState.attach(Downgraded).get().dropoffList];
    //   values[i].dropoffAddress = event.target.value;
    //   state.dropoffList.set(values);
    // }

    // const handleChangeDateTime = (event,i) => {
    //     const values = gTransportState.attach(Downgraded).get().dropoffList
    //     values[i].dropoffDate = `${Helper.FormatYearDate(event)}T${Helper.FormatTime24(event)}`;
    //     state.dropoffList.set(values);
    // }

    // const handleAdd = () => {
    //   const values = state.attach(Downgraded).get().dropoffList
    //   values.push({ dropoffDate: `${Helper.FormatYearDate(new Date())}T${Helper.FormatTime24(new Date())}` , dropoffAddress: null });
    //   state.dropoffList.set(values);
    // }

    const handleRemove = (i) =>
    {
        const values = [
            ...gTransportState.attach(Downgraded).get().dropoffList,
        ];
        values.splice(i, 1);
        state.dropoffList.set(values);
        handleDisableBtn();
    };

    const handleChangeVType = (event) =>
    {
        state.vehicleType.set(event.target.value);
    };

    const handleChangePassenger = (event) =>
    {
        state.totalPassengers.set(event.target.value);
        //setPassenger(event.target.value);
        const passCount = event.target.value;

        const values = [...gTransportState.attach(Downgraded).get().peopleInfo];

        if (state.peopleInfo.length > passCount)
        {
            const len = state.peopleInfo.length - passCount;
            values.splice(-len, len);
        } else
        {
            const lenghCheck = passCount - state.peopleInfo.length;
            for (let i = 0; i < lenghCheck; i++)
            {
                values.push({
                    name: null,
                    dob: `${Helper.FormatYearDate(
                        new Date()
                    )}T${Helper.FormatTime24(new Date())}`,
                });
            }
        }
        state.peopleInfo.set(values);
        //setAdditionalPass(values)
    };

    const handleAddPass = (event, index) =>
    {
        const values = [...gTransportState.attach(Downgraded).get().peopleInfo];
        values[index].name = event.target.value;
        state.peopleInfo.set(values);
    };

    const handleBtnCancel = () =>
    {
        props.history.goBack();
        // props.history.push(RouteConstants.EVENT_TRANSIT);
    };

    useEffect(() =>
    {
        if (!props.transitID)
        {
            resetState();
        }
        getParticipantList()
        // console.log(state.pickupTime.get());
        // getEventModulesData();
    }, []);
    // const getEventModulesData = () =>
    // {
    //     const eventInfo = Helper.getStorage('eventInfo');
    //     ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
    //         .then((res) =>
    //         {
    //             if (res.data)
    //             {
    //                 res.data.map((auto) =>
    //                 {
    //                     // console.log("auto.moduleName",auto.moduleName);
    //                     if (auto.moduleName === "Transportation")
    //                     {
    //                         // console.log(auto.autoApprove)
    //                         setAutoApprove(auto.autoApprove)
    //                     }
    //                 })
    //             }
    //         })
    // }

    useEffect(() =>
    { 
        if (
            props.transitInfo &&
            (currentTransportInfo.get() == null ||
                currentTransportInfo.get().draftCombineTransportID !=
                props.transitInfo.draftCombineTransportID)
        )
        {
            let transportInfo = props.transitInfo;
            
            if (prevTransInfo.attach(Downgraded).get() === null)
            {
                let dropList = [];
                transportInfo.dropoffList &&
                    transportInfo.dropoffList.map((item) =>
                    {
                        let obj = {
                            dropoffAddress: item.dropoffAddress,
                            dropoffDate: Helper.FormatDateTime24(
                                item.dropoffDate
                            ),
                        };
                        dropList.push(obj);
                    });
                let obj = {
                    draftCombineTransportID: transportInfo.draftCombineTransportID,
                    draftCombineGroundTransportID: transportInfo.draftCombineGroundTransportID,
                    eventID: transportInfo.eventID,
                    transportType: transportInfo.transportType,
                    vehicleType: transportInfo.vehicleType,
                    totalPassengers: transportInfo.totalPassengers,
                    firstName: transportInfo.firstName,
                    lastName: transportInfo.lastName,
                    email: transportInfo.email,
                    contactNo: transportInfo.contactNo,
                    pickupDate: transportInfo.pickupDate,
                    pickupTime: transportInfo.pickupDate,
                    pickupAddress: transportInfo.pickupAddress,
                    createdBy: transportInfo.createdBy,
                    addedFor: transportInfo.addedFor,
                    note: transportInfo.note,
                    shared: transportInfo.shared,
                    requestStatus: transportInfo.requestStatus,
                    dropoffList: dropList,
                    peopleInfo: transportInfo.peopleInfo,
                };
                prevTransInfo.set(obj);
            }
            if (transportInfo.draftCombineTransportID > 0)
            {
                state.set(transportInfo);
                currentTransportInfo.set(transportInfo);
                state.draftCombineTransportID.set(transportInfo.draftCombineTransportID);
                state.draftCombineGroundTransportID.set(transportInfo.draftCombineGroundTransportID);
                state.pickupTime.set(Helper.FormatTime24(transportInfo.pickupDate));
                if (transportInfo.addedFor && props.participantList)
                {
                    const index = props.participantList.findIndex(
                        (user) => user.userID == transportInfo.addedFor
                    );
                    if (index > -1)
                    {
                        setParticipant(props.participantList[index]);
                    }
                    state.addedFor.set(transportInfo.addedFor);
                }
            }
        }
    }, [props]);

    const resetState = () =>
    {
        state.set({
            // firstName: agentState.visible.value ? userInfo.firstName : '',
            // lastName: agentState.visible.value ? userInfo.lastName : '',
            // email: agentState.visible.value ? userInfo.email : '',
            firstName: '',
            lastName: '',
            email: '',
            contactNo: '',
            pickupAddress: '',
            vehicleType: 'SUV',
            totalPassengers: 1,
            pickupDate: null,
            pickupTime: null,
            peopleInfo: [
                {
                    name: '',
                    dob: `${Helper.FormatYearDate(
                        new Date()
                    )}T${Helper.FormatTime24(new Date())}`,
                },
            ],
            dropoffList: [],
            isDisable: false,
            dateTimeError: false,
            dateTimeErrorMsg: '',
        });
    };

    function dateTimeChecker(arr, element)
    {
        if (arr != null && arr.length > 0)
        {
            for (var i = 0; i < arr.length; i++)
            {
                if (moment(arr[i].dropoffDate).isSameOrAfter(element, 'day'))
                    return true;
            }
        }
        return false;
    }
    const getParticipantList = () =>
    {
        const gEventInfo = Helper.getStorage('eventInfo');
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) =>
            {
                if (res.data.rows)
                {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setAllParticipantList(participants);
                }
            });
    }

    const handleSubmit = (event) =>
    {
        event.preventDefault();
        const userInfo = Helper.getStorage('userInfo');

        // if(
        //     (
        //         Helper.isAdminUser(userInfo) ||
        //         (userInfo.roles && Helper.isEventAdmin(userInfo))
        //     ) &&
        //     participant == null
        // ) {
        //     props.setSnackBarProps({
        //         ...props.snackBarProps,
        //         openSnack: true,
        //         variant: 'error',
        //         message:
        //             'Please select participant first',
        //     });
        //     return false;
        // }
        // console.log("phoneErr",phoneErr);
        if (
            firstNameErr.length > 0 ||
            lastNameErr.length > 0 ||
            emailErr.length > 0
        )
        {
            return false;
        }
        // console.log(gTransportState.attach(Downgraded).get().dropoffList)
        const pickupDate = state.pickupDate.get();
        const dateCheck = dateTimeChecker(
            gTransportState.attach(Downgraded).get().dropoffList,
            pickupDate
        );
        const eventInfo = Helper.getStorage('eventInfo');

        if (
            state.draftCombineTransportID.get() == 0 &&
            (moment(state.pickupDate.get()).isValid() == false ||
                moment(state.pickupDate.get()).isBefore(new Date(), 'day'))
        )
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select valid date & time',
            });
        } else if (!state.pickupTime.get() || state.pickupTime.get() == null)
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select time',
            });
        } else if (
            gTransportState.attach(Downgraded).get().dropoffList.length > 0 &&
            dateCheck == false
        )
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Invalid Drop Off Date',
            });
        } else if (
            gTransportState.attach(Downgraded).get().email !== '' &&
            !Helper.validEmail(
                gTransportState.attach(Downgraded).email.get().trim()
            )
        )
        {
            setEmailErr('Please enter valid emailid');
        } else if (
            gTransportState.attach(Downgraded).get().dropoffList.length < 1
        )
        {
            props.setSnackBarProps({
                ...props.snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please Select at least one dropoff info',
            });
        } else
        {
            // console.log(state.pickupTime.get())
            let requestObj = {};
            let date = `${Helper.FormatYearDate(
                state.pickupDate.get()
            )}T${state.pickupTime.get()}:00`;
            requestObj.draftCombineTransportID = state.draftCombineTransportID.get();
            requestObj.draftCombineGroundTransportID = state.draftCombineGroundTransportID.get();
            requestObj.eventID = eventInfo.eventID;
            requestObj.transportType = 'Ground';
            requestObj.vehicleType = state.vehicleType.get();
            requestObj.totalPassengers = state.totalPassengers.get();
            requestObj.firstName = state.firstName.get();
            requestObj.lastName = state.lastName.get();
            requestObj.email = state.email.get();
            requestObj.contactNo = state.contactNo.get();
            requestObj.pickupDate = date;
            requestObj.pickupAddress = state.pickupAddress.get();
            requestObj.dropoffList = gTransportState
                .attach(Downgraded)
                .get().dropoffList;
            requestObj.peopleInfo = [];
            // requestObj.peopleInfo = gTransportState
            //     .attach(Downgraded)
            //     .get().peopleInfo;
            requestObj.createdBy = agentState.visible.value
                ? agentInfo.userID
                : userInfo.userID;
            // this will be changed as per selected user
            requestObj.addedFor = participant
                ? participant.userID
                : state.addedFor.get()
                    ? state.addedFor.get()
                    : userInfo.userID;

            loading.set(true);
            state.isDisable.set(true);
            // console.log(requestObj)
            ApiHelper.post(APIURLConstants.POST_UPD_DRAFT_COMBINE_GND_TRANSPORT, requestObj)
                .then(async (res) =>
                {
                    if (res.data)
                    {
                        if (props.transitID > 0)
                        {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Request updated successfully',
                            });
                        } else
                        {
                            props.setSnackBarProps({
                                ...props.snackBarProps,
                                openSnack: true,
                                variant: 'success',
                                message: 'Request created successfully',
                            });
                        }
                        loading.set(false);
                        // if (autoApprove === 1 || props.transitID > 0)
                        // {
                            let isPublished=allParticipantList.filter((x)=>x.isPublished===true && x.userID===requestObj.addedFor)
                        //     if(isPublished.length>0){
                        // SETEmailNotification(requestObj);
                        //     }
                        // }
                        updateModuleState();
                        setTimeout(() =>
                        {
                            state.isDisable.set(false);
                            if (
                                Helper.isAdminUser(userInfo) ||
                                (userInfo.roles &&
                                    Helper.isEventAdmin(userInfo)) ||
                                (userInfo.roles &&
                                    Helper.isEventStaff(userInfo))
                            )
                            {
                                // props.history.push(
                                //     generatePath(
                                //         RouteConstants.EVENT_TRANSIT_LIST,
                                //         { eventID: eventInfo.eventID }
                                //     )
                                // );
                                props.history.goBack();
                            } else
                            {
                                props.history.push(
                                    generatePath(RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                            }
                        }, 1000);
                        
                    }
                })
                .catch((error) =>
                {
                    console.log("error", error);
                    loading.set(false);
                    state.isDisable.set(false);
                    if (error.response && error.response.status === 401)
                    {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Access denied',
                        });
                    } else
                    {
                        props.setSnackBarProps({
                            ...props.snackBarProps,
                            openSnack: true,
                            variant: 'error',
                            message: 'Error while creating request',
                        });
                    }
                });
        }
    };

    // const SETEmailNotification = (ObjRequest) =>
    // {
    //     ApiHelper.post(
    //         APIURLConstants.POST_SET_DRAFT_COMBINE_GROUND_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) =>
    //         {
    //             console.log(result.data);
    //         })
    //         .catch((err) =>
    //         {
    //             console.log(err);
    //         });
    // };

    const handleEditData = (date, field, id) =>
    {
        openDialog.set(true);
        stateObj.set({ date: date, address: field, id: id });
    };

    const handleClick = () =>
    {
        openDialog.set(true);
        stateObj.set(null);
    };

    const handleClose = () =>
    {
        openDialog.set(false);
    };

    const handleAction = (dateTime, address, i) =>
    {
        const values = [
            ...gTransportState.attach(Downgraded).get().dropoffList,
        ];
        console.log("asdasd",values, i);
        if (dateTime && address && i >= 0)
        {
            console.log(values, i);
            values[i].dropoffDate = `${Helper.FormatYearDate(
                dateTime
            )}T${Helper.FormatTime24(dateTime)}`;
            values[i].dropoffAddress = address;
            state.dropoffList.set(values);
        } else
        {
            console.log("values1",values);
            values.push({
                dropoffDate: `${Helper.FormatYearDate(
                    dateTime
                )}T${Helper.FormatTime24(dateTime)}`,
                dropoffAddress: address,
            });
            state.dropoffList.set(values);
        }
console.log("values",values);
        openDialog.set(false);
    };

    const changeParticipant = (participant) =>
    {
        if (participant)
        {
            resetState();
            const [lastName, firstName] = [...participant.name.split(', ')];
            state.firstName.set(firstName);
            state.lastName.set(lastName);
        } else
        {
            // state.firstName.set('');
            // state.lastName.set('');
            resetState();
        }

        setParticipant(participant);
    };

    const checkValidPhone = (e) =>
    {
        state.contactNo.set(e)
        const phone = e;

        // const phone = state.contactNo.get();
        // if (phone != '')
        // {
        //     if (
        //         phone.match(/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/)
        //     )
        //     {
        //         setPhoneErr('');
        //     } else
        //     {
        //         setPhoneErr('Please enter valid contact number');
        //     }
        // } else
        // {
        //     setPhoneErr('');
        // }
        handleDisableBtn();
        //validatePhone(e);
    };

    const handleDisableBtn = () =>
    {
        if (props.transitID > 0)
        {
            const prevData = prevTransInfo.attach(Downgraded).get();
            let transportInfo = props.transitInfo;

            let dropList = [];
            state.attach(Downgraded).get().dropoffList &&
                state
                    .attach(Downgraded)
                    .get()
                    .dropoffList.map((item) =>
                    {
                        let obj = {
                            dropoffAddress: item.dropoffAddress,
                            dropoffDate: Helper.FormatDateTime24(
                                item.dropoffDate
                            ),
                        };
                        dropList.push(obj);
                    });
            const currentData = {
                draftCombineTransportID: state.get().draftCombineTransportID,
                draftCombineGroundTransportID: state.get().draftCombineGroundTransportID,
                eventID: currentTransportInfo.get().eventID,
                transportType: transportInfo.transportType,
                vehicleType: state.get().vehicleType,
                totalPassengers: state.get().totalPassengers,
                firstName: state.get().firstName,
                lastName: state.get().lastName,
                email: state.get().email,
                contactNo: state.get().contactNo,
                pickupDate: state.get().pickupDate,
                pickupAddress: state.get().pickupAddress,
                createdBy: transportInfo.createdBy,
                addedFor: transportInfo.addedFor,
                note: transportInfo.note,
                shared: transportInfo.shared,
                requestStatus: transportInfo.requestStatus,
                dropoffList: dropList,
                peopleInfo: state.get().peopleInfo,
            };
            console.log(prevData, currentData)
            if (JSON.stringify(prevData) === JSON.stringify(currentData))
            {
                setDisableBtn(true);
            } else
            {
                setDisableBtn(false);
            }
        }
    };
    const getPrevInfo = () =>
    {
        if (props.transitID > 0)
        {
            loading.set(true);
            if (prevTransInfo.get() != null)
            {
                prevTransInfo.set(null);
                let transportInfo = props.transitInfo;
                ApiHelper.get(
                    APIURLConstants.GET_DRAFT_COMBINE_GNDTRANSPORT_ROW(
                        transportInfo.draftCombineTransportID
                    )
                )
                    .then((res) =>
                    {
                        if (res.data)
                        {
                            let data = res.data;
                            let dropList = [];
                            data.dropoffList &&
                                data.dropoffList.map((item) =>
                                {
                                    let obj = {
                                        dropoffAddress: item.dropoffAddress,
                                        dropoffDate: Helper.FormatDateTime24(
                                            item.dropoffDate
                                        ),
                                    };
                                    dropList.push(obj);
                                });
                            let obj = {
                                draftCombineTransportID: data.draftCombineTransportID,
                                draftCombineGroundTransportID: data.draftCombineGroundTransportID,
                                eventID: data.eventID,
                                transportType: data.transportType,
                                vehicleType: data.vehicleType,
                                totalPassengers: data.totalPassengers,
                                firstName: data.firstName,
                                lastName: data.lastName,
                                email: data.email,
                                contactNo: data.contactNo,
                                pickupDate: data.pickupDate,
                                pickupAddress: data.pickupAddress,
                                createdBy: data.createdBy,
                                addedFor: data.addedFor,
                                note: data.note,
                                shared: data.shared,
                                requestStatus: data.requestStatus,
                                dropoffList: dropList,
                                peopleInfo: data.peopleInfo,
                            };
                            prevTransInfo.set(obj);
                        }
                    })
                    .catch((error) =>
                    {
                        console.log('error : ', error);
                        loading.set(false);
                    })
                    .then(() =>
                    {
                        handleDisableBtn();
                        loading.set(false);
                    });
            }
        }
    };
    return (
        <>
            {loading.get() ? (
                <Box className={classes.loader}>
                    <CircularProgress />
                </Box>
            ) : (
                <Box
                    component="form"
                    sx={{ width: '100%', backgroundColor: '#fff' }}
                    onSubmit={handleSubmit}>
                    {/* <Box
                        sx={{
                            border: 1,
                            borderColor: 'grey.300',
                            boxShadow: 3,
                            borderRadius: 2,
                            p: 2,
                        }}> */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            flex: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}>
                            <Box
                                component="img"
                                className={classes.mobileLogo}
                                alt="logo."
                                src={SedanBlue}
                            />
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    paddingLeft: 3,
                                }}>
                                <Typography
                                    variant="h4"
                                    fontSize={{ xs: '15px', md: '22px' }}
                                    fontWeight={300}
                                    fontFamily={'Lato'}
                                    color="primary"
                                    pb={1}>
                                    Ground Transport
                                </Typography>
                            </Box>
                        </Box>

                        <Divider
                            orientation="vertical"
                            light={false}
                            sx={{ marginLeft: 2, marginRight: 5 }}
                            flexItem
                        />

                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                flex: 0.5,
                            }}>
                            <ParticipantAutoList
                                disableParticipant={
                                    props.transitInfo &&
                                        props.transitInfo.draftCombineGroundTransportID
                                        ? true
                                        : false
                                }
                                participant={participant}
                                setParticipant={changeParticipant}
                                participantList={props.participantList}
                                modPermission={props.modPermission}
                            />
                            {/* <Typography
                                variant="h4"
                                fontSize={16}
                                fontWeight={400}
                                component="div"
                                marginTop={{ xs: 3, md: 0 }}
                                color="#3D9AB7"
                                pb={1}>
                                Registrant Information
                            </Typography>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={12}
                                        fontWeight={300}
                                        noWrap
                                        component="div">
                                        First
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        noWrap
                                        component="div">
                                        John
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        flexWrap: 'wrap',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        noWrap
                                        component="div">
                                        Last
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        noWrap
                                        component="div">
                                        Doe
                                    </Typography>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        flexDirection: 'column',
                                    }}>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        component="div">
                                        Registration Type
                                    </Typography>
                                    <Typography
                                        variant="h4"
                                        fontSize={14}
                                        fontWeight={400}
                                        noWrap
                                        component="div">
                                        0
                                    </Typography>
                                </Box>
                            </Box> */}
                        </Box>
                    </Box>
                    <Divider
                        light={false}
                        sx={{ marginTop: 2, marginRight: 0 }}
                        flexItem
                    />
                    {/* not needed for draft combine */}
                    {/* <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                        }}>
                        <Box
                            component="img"
                            className={classes.sedanBlack}
                            alt="logo."
                            src={SedanBlackSmall}
                        />
                        <Typography
                            variant="h4"
                            fontSize={{ xs: '12px', md: '16px' }}
                            fontWeight={500}
                            paddingLeft={1}
                            paddingTop={1}
                            fontFamily={'Lato'}
                            color="primary"
                            pb={1}>
                            VEHICLE INFORMATION
                        </Typography>
                    </Box>
                    <Divider
                        light={false}
                        sx={{ marginTop: 0, marginRight: 0 }}
                        flexItem
                    /> */}
                    {/* <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', md: 'row' },
                            padding: 1,
                            flex: 1,
                            marginTop: 1,
                        }}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                            }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    flex: 0.98,
                                    alignItems: 'center',
                                }}>
                                <FormControl fullWidth={false} size="small">
                                    <InputLabel id="demo-simple-select-label">
                                        Vehicle Type
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={state.vehicleType.get()}
                                        label="Select Vehicle"
                                        onChange={handleChangeVType}>
                                        {vehicleTypes &&
                                            vehicleTypes.map((option) => (
                                                <MenuItem
                                                    key={option.value}
                                                    value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </Box>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                flex: 0.5,
                                alignItems: 'center',
                                marginTop: { xs: 2, md: 0 },
                            }}>
                            <FormControl fullWidth={false} size="small">
                                <InputLabel id="demo-simple-select-label">
                                    Passengers
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={state.totalPassengers.get()}
                                    label="Select Vehicle"
                                    onChange={handleChangePassenger}>
                                    {passengers.map((option) => (
                                        <MenuItem
                                            key={option.value}
                                            value={option.value}>
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>

                    <Divider
                        light={false}
                        sx={{ marginTop: 2, marginRight: 0 }}
                        flexItem
                    /> */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                        }}>
                        <Box
                            component="img"
                            className={classes.sedanBlack}
                            alt="logo."
                            src={SedanBlackSmall}
                        />
                        <Typography
                            variant="h4"
                            fontSize={{ xs: '12px', md: '16px' }}
                            fontWeight={500}
                            paddingLeft={1}
                            paddingTop={1}
                            fontFamily={'Lato'}
                            color="primary"
                            pb={1}>
                            PICKUP INFORMATION
                        </Typography>
                    </Box>
                    <Divider light={false} flexItem />

                    <Grid
                        container
                        rowSpacing={2}
                        columnSpacing={1}
                        sx={{
                            padding: 0,
                            marginTop: 1,
                        }}>
                        <Grid item lg={4} md={6} xs={12}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="First Name"
                                autoComplete="off"
                                value={state.firstName.get()}
                                onChange={(event) =>
                                {
                                    state.firstName.set(event.target.value),
                                        setFirstNameErr('');
                                    handleDisableBtn();
                                }}
                                onBlur={validateFirstName}
                                error={firstNameErr.length > 0 ? true : false}
                                helperText={
                                    firstNameErr.length > 0 ? firstNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="Last Name"
                                autoComplete="off"
                                value={state.lastName.get()}
                                onChange={(event) =>
                                {
                                    state.lastName.set(event.target.value),
                                        setLastNameErr('');
                                    handleDisableBtn();
                                }}
                                onBlur={validateLastName}
                                error={lastNameErr.length > 0 ? true : false}
                                helperText={
                                    lastNameErr.length > 0 ? lastNameErr : ''
                                }
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <TextField
                                size="small"
                                id="outlined-required"
                                label="Email"
                                value={state.email.get()}
                                autoComplete="off"
                                onChange={(event) =>
                                {
                                    state.email.set(event.target.value),
                                        setEmailErr('');
                                    handleDisableBtn();
                                }}
                                onBlur={validateEmail}
                                error={emailErr.length > 0 ? true : false}
                                helperText={emailErr.length > 0 ? emailErr : ''}
                                inputProps={{ maxLength: 50 }}
                            />
                        </Grid>

                        <Grid item lg={4} md={6} xs={12}>
                            {/* <InputMask
                                mask="(999) 999-9999"
                                value={
                                    state.contactNo.value
                                }
                                defaultValue={
                                    state.contactNo.value
                                }
                                onBlur={checkValidPhone}
                                onChange={(
                                    e
                                ) =>
                                {
                                    state.contactNo.set(e.target.value);
                                    //handlePhoneChange(e,index)
                                    // checkValidPhone(
                                    //     e
                                    // );
                                    handleDisableBtn();
                                }}>
                                {() => (
                                    <TextField
                                        size="small"
                                        id="outlined-required"
                                        label="Contact Number"
                                        value={state.contactNo.value}
                                        // onChange={(event) => {
                                        //     state.contactNo.set(event.target.value),
                                        //         setPhoneErr('');
                                        // }}
                                        autoComplete="off"
                                        // onBlur={validatePhone}
                                        error={phoneErr.length > 0 ? true : false}
                                        helperText={phoneErr.length > 0 ? phoneErr : ''}
                                    />
                                )}
                            </InputMask> */}

                            {/* <InputMask
                                mask="(999) 999-9999"
                                value={state.contactNo.value}
                                defaultValue={state.contactNo.value}
                                onChange={(e) =>
                                {
                                    state.contactNo.set(e.target.value);
                                    checkValidPhone(e);
                                    handleDisableBtn();
                                }}>
                                {() => (
                                    <TextField
                                        error={
                                            phoneErr.length > 0 ? true : false
                                        }
                                        size="small"
                                        id="outlined-required"
                                        value={state.contactNo.value}
                                        label="Contact Number"
                                        fullWidth
                                        variant="outlined"
                                        autoComplete="off"
                                        helperText={
                                            phoneErr.length > 0 ? phoneErr : ''
                                        }
                                    />
                                )}
                            </InputMask> */}
                            <PhoneNumber
                                name={'groundContact'}
                                placeholder="Contact Number"
                                value={state.contactNo.value}
                                onChange={checkValidPhone}
                                required={false}
                            />
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                        <MUIDatePicker
                            label="Start Date"
                            value={state.pickupDate
                                .attach(Downgraded)
                                .get()}
                            // minDate={
                            //         state.draftCombineTransportID.get() > 0
                            //             ? null
                            //             : new Date()
                            //     }
                            error={
                                state.dateTimeErrorMsg.get()
                                    ? state.dateTimeErrorMsg.get()
                                        .length > 0
                                        ? true
                                        : false
                                    : false
                            }
                            setValue={handleDateTime}
                        />
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    label="Start Date"
                                    value={state.pickupDate
                                        .attach(Downgraded)
                                        .get()}
                                    inputProps={{ readOnly: true }}
                                    allowKeyboardControl={false}
                                    minDate={
                                        state.draftCombineTransportID.get() > 0
                                            ? null
                                            : new Date()
                                    }
                                    onChange={(newValue) =>
                                        handleDateTime(newValue)
                                    }
                                    cancelText
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            size="small"
                                            helperText={state.dateTimeErrorMsg.get()}
                                            autoComplete="off"
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            error={
                                                state.dateTimeErrorMsg.get()
                                                    ? state.dateTimeErrorMsg.get()
                                                        .length > 0
                                                        ? true
                                                        : false
                                                    : false
                                            }
                                        />
                                    )}
                                />
                            </LocalizationProvider> */}
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    label="Time"
                                    value={state.pickupTime
                                        .attach(Downgraded)
                                        .get()}
                                    onChange={(newValue) =>
                                        handleEndTime(newValue)
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            required
                                            size="small"
                                            helperText={endTimeErr}
                                            fullWidth
                                            autoComplete="off"
                                            onKeyDown={(e) =>
                                                e.preventDefault()
                                            }
                                            error={
                                                endTimeErr.length > 0
                                                    ? true
                                                    : false
                                            }
                                        />
                                    )}
                                />
                            </LocalizationProvider> */}
                            <Stack component="form" noValidate spacing={3}>

                                <TextField
                                    required
                                    id="time"
                                    label="Time"
                                    type="time"
                                    size="small"
                                    value={state.pickupTime
                                        .attach(Downgraded)
                                        .get() === null ? '' : state.pickupTime
                                            .attach(Downgraded)
                                            .get()}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    inputProps={{
                                        step: 300, // 5 min
                                    }}
                                    onChange={(e) =>
                                    {
                                        state.pickupTime.set(e.target.value)
                                        handleDisableBtn()
                                    }}
                                    sx={{ width: 150 }}
                                    error={
                                        endTimeErr.length > 0
                                            ? true
                                            : false
                                    }
                                    helperText={endTimeErr}

                                />

                            </Stack>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                            <TextField
                                size="small"
                                required
                                id="outlined-required"
                                label="Pickup Location"
                                value={state.pickupAddress.get()}
                                onChange={(event) =>
                                {
                                    state.pickupAddress.set(event.target.value);
                                    handleDisableBtn();
                                }}
                                multiline={true}
                                minRows={3}
                                maxRows={10}
                                inputProps={{ maxLength: 260 }}
                            />
                        </Grid>
                    </Grid>

                    <Divider
                        light={false}
                        sx={{ marginTop: 2, marginRight: 0 }}
                        flexItem
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                            flex: 1,
                        }}>
                        <Box
                            component="img"
                            className={classes.sedanBlack}
                            alt="logo."
                            src={SedanBlackSmall}
                        />
                        <Box flex={0.98}>
                            <Typography
                                variant="h4"
                                fontSize={{ xs: '12px', md: '16px' }}
                                fontWeight={500}
                                paddingLeft={1}
                                paddingTop={1}
                                fontFamily={'Lato'}
                                color="primary"
                                pb={1}>
                                DROPOFF INFORMATION
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                alignSelf: 'center',
                                display: 'flex',
                            }}
                            flex={0.03}
                            onClick={handleClick}>
                            <AddCircleRoundedIcon sx={{ color: '#008000' }} />
                        </Box>
                    </Box>

                    <Divider light={false} flexItem />

                    {state.dropoffList.attach(Downgraded).get().length > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                backgroundColor: '#F1F6FF',
                                flex: 1,
                                marginTop: 2,
                            }}>
                            <Box flex={0.3} sx={{ justifyContent: 'center' }}>
                                <Typography
                                    variant="h2"
                                    fontSize={{ xs: '12px', md: '14px' }}
                                    fontWeight={700}
                                    paddingLeft={1}
                                    paddingTop={1}
                                    sx={{ paddingLeft: 5 }}
                                    pb={1}>
                                    Date & Time
                                </Typography>
                            </Box>

                            <Box
                                flex={0.7}
                                maxLength={10}
                                style={{ wordBreak: 'break-all' }}>
                                <Typography
                                    variant="h2"
                                    fontSize={{ xs: '12px', md: '14px' }}
                                    fontWeight={700}
                                    paddingLeft={1}
                                    paddingTop={1}
                                    pb={1}>
                                    Dropoff Location
                                </Typography>
                            </Box>
                        </Box>
                    )}

                    {state.dropoffList.attach(Downgraded).get().length > 0 &&
                        state.dropoffList
                            .attach(Downgraded)
                            .get()
                            .map((field, idx) =>
                            {
                                return (
                                    <Box
                                        key={idx}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            alignItems: 'center',
                                            flex: 1,
                                            marginTop: 1,
                                            backgroundColor: '#f8f8f8',
                                        }}>
                                        <Box
                                            flex={0.3}
                                            sx={{ justifyContent: 'center' }}>
                                            <Typography
                                                variant="h2"
                                                fontSize={{
                                                    xs: '10px',
                                                    md: '14px',
                                                }}
                                                fontWeight={400}
                                                paddingLeft={1}
                                                paddingTop={1}
                                                sx={{ paddingLeft: 5 }}
                                                pb={1}>
                                                {`${Helper.FormatYearDate(
                                                    field.dropoffDate
                                                )} ${Helper.FormatTime24(
                                                    field.dropoffDate
                                                )}`}
                                            </Typography>
                                        </Box>

                                        <Box
                                            flex={0.7}
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                            }}>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flex: 0.9,
                                                }}>
                                                <Typography
                                                    variant="h2"
                                                    fontSize={{
                                                        xs: '10px',
                                                        md: '14px',
                                                    }}
                                                    fontWeight={400}
                                                    paddingLeft={1}
                                                    paddingTop={1}
                                                    sx={{
                                                        wordBreak: 'break-all',
                                                    }}
                                                    pb={1}>
                                                    {field.dropoffAddress}
                                                </Typography>
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flex: 0.05,
                                                }}>
                                                <Box
                                                    component="img"
                                                    className={
                                                        classes.sedanBlack
                                                    }
                                                    alt="logo."
                                                    src={IconPencil}
                                                    onClick={() =>
                                                        handleEditData(
                                                            field.dropoffDate,
                                                            field.dropoffAddress,
                                                            idx
                                                        )
                                                    }
                                                />
                                            </Box>
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    flex: 0.05,
                                                }}>
                                                <Box
                                                    component="img"
                                                    className={
                                                        classes.sedanBlack
                                                    }
                                                    alt="logo."
                                                    src={trash}
                                                    onClick={() =>
                                                        handleRemove(idx)
                                                    }
                                                />
                                            </Box>
                                        </Box>
                                    </Box>
                                );
                            })}
                    {/* not needed for draft combine */}
                    {/* <Divider
                        light={false}
                        sx={{ marginTop: 2, marginRight: 0 }}
                        flexItem
                    />
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            backgroundColor: '#f8f8f8',
                        }}>
                        <Box
                            component="img"
                            className={classes.sedanBlack}
                            alt="logo."
                            src={AdditionalPass}
                        />
                        <Typography
                            variant="h4"
                            fontSize={{ xs: '12px', md: '16px' }}
                            fontWeight={500}
                            paddingLeft={1}
                            paddingTop={1}
                            fontFamily={'Lato'}
                            color="primary"
                            pb={1}>
                            ADDITIONAL PASSENGERS
                        </Typography>
                    </Box>
                    <Divider light={false} flexItem /> */}

                    {/* {state.peopleInfo.attach(Downgraded).get() &&
                        state.peopleInfo
                            .attach(Downgraded)
                            .get()
                            .map((item, index) => {
                                return (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: 'flex',
                                            flexDirection: {
                                                xs: 'column',
                                                md: 'row',
                                            },
                                            padding: 0,
                                            flex: 1,
                                            marginTop: 1,
                                        }}>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                flexDirection: 'row',
                                                flex: 0.5,
                                                alignItems: 'center',
                                                padding: 1,
                                            }}>
                                            <TextField
                                                size="small"
                                                id="outlined-required"
                                                label="Passengers"
                                                autoComplete="off"
                                                value={item.name}
                                                onChange={(event) =>
                                                    handleAddPass(event, index)
                                                }
                                            />
                                        </Box>
                                    </Box>
                                );
                            })} */}

                    <Divider component="div" />
                    <br />
                    {/* {renderIsDisable()} */}

                    <ButtonContainer
                        //handleClick={handleClick}
                        handleCancel={handleBtnCancel}
                        buttonText={props.transitID > 0 ? 'Update' : 'Create'}
                        disableButton={state.isDisable.get()}
                        disableUpdateButton={
                            props.transitID > 0 ? disableBtn : false
                        }
                    />

                    {/* </Box> */}
                    {openDialog.get() && (
                        <CreateDateTimeLocation
                            open={openDialog.get()}
                            title="Update Dropoff Information"
                            handleClose={handleClose}
                            handleAction={handleAction}
                            handleData={stateObj.get()}
                            handlePickupDate={state.pickupDate
                                .attach(Downgraded)
                                .get()}
                            prevInfo={prevTransInfo.attach(Downgraded).get()}
                            getPrevInfo={getPrevInfo}
                            draftCombineTransportID={
                                props.transitInfo
                                    ? props.transitInfo.draftCombineTransportID
                                    : 0
                            }
                        />
                    )}
                </Box>
            )}
        </>
    );
};
export default GroundTransport;
